import React, { createContext, useContext, useState } from 'react';

const GenderContext = createContext();

export const useGender = () => useContext(GenderContext);

export const GenderProvider = ({ children }) => {
  const [selectedGender, setSelectedGender] = useState('Men');

  return <GenderContext.Provider value={{ selectedGender, setSelectedGender }}>{children}</GenderContext.Provider>;
};
